   <ng-container *ngIf="user; else sign_in">
        <mat-nav-list class="wrapper">
            <mat-list-item class="user-info-grid " [matMenuTriggerFor]="menu">
                <div matListAvatar class="avatar-container">
                    <mat-icon class="avatar" aria-hidden="false" aria-label="User icon">account_circle</mat-icon>
                </div>
                <div matLine class="name">{{ user?.firstName }} {{ user?.lastName }}</div>
                <div matLine class="userRole">{{ role }}</div>
                <div class="menuArrow">
                    <mat-icon aria-label="Down arrow icon for menu">expand_more</mat-icon>
                </div>
            </mat-list-item>
        </mat-nav-list>
        <mat-menu #menu="matMenu" xPosition="before">
            <!-- <button mat-menu-item>Need Help</button> -->
            <button mat-menu-item (click)="logout()">
                <mat-icon>login</mat-icon>Sign Out
            </button>
        </mat-menu>
    </ng-container>

    <ng-template #sign_in>
        <mat-action-list class="signIn">
            <button mat-list-item (click)="login()"> SIGN IN </button>
        </mat-action-list>
    </ng-template>
<mat-divider></mat-divider>
